/**
 * The default name for a new wholesaler-level service profile.
 *
 * Every profile editor built this string itself, so the shape and the
 * no-wholesaler-yet fallback were written out in 14 places. The fallback is
 * load-bearing: the wholesaler name arrives from `/wholesaler/{id}` after first
 * paint, and without it the header renders a dangling " - " (Bug 2807).
 *
 * @param {string} [wholesalerName] Resolved name, or falsy while it loads.
 * @param {string} label Platform label, e.g. 'Zoom' or 'Webex'.
 * @returns {string}
 */
export const resolveWholesalerProfileName = (wholesalerName, label) =>
    wholesalerName
        ? `${wholesalerName} - ${label} Wholesaler Profile`
        : `${label} Wholesaler Profile`;
